import { render } from "./UiPropFieldAlias.vue?vue&type=template&id=8f7f0170"
import script from "./UiPropFieldAlias.vue?vue&type=script&lang=js"
export * from "./UiPropFieldAlias.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__